<div class="flex flex-col gap-4">
  <p class="text-lg">
    {{ 'profile.details.intro_text' | translate }}
  </p>

  <div class="flex flex-col gap-4 rounded bg-pl-gray-100 p-6 text-lg shadow-md">
    <div>
      <p class="font-bold">{{ 'utils.name' | translate }}</p>
      <p>{{ participantFullName() }}</p>
    </div>

    <div>
      <p class="font-bold">{{ 'utils.email' | translate }}</p>
      <p>{{ participantEmail() }}</p>
    </div>

    <div>
      <pl-button
        class="!w-fit"
        [variant]="ButtonVariant.lightGray"
        [isDisabled]="disableSendEmailButton()"
        (click)="sendResetPasswordEmail()"
      >
        <ng-container *ngIf="!resetPasswordEmailSent()">{{
          'profile.details.reset_password' | translate
        }}</ng-container>
        <div *ngIf="resetPasswordEmailSent()" class="flex items-center justify-center gap-2">
          <pl-icon [name]="PlIcon.tick" class="h-6 w-6" /> <span>{{ 'profile.details.email_sent' | translate }}</span>
        </div>
      </pl-button>
      <p *ngIf="resetPasswordEmailSent()" class="text-xs text-pl-green-700">
        {{ 'profile.details.email_sent_to_you' | translate }}
      </p>
      <p *ngIf="errorSendingEmail()" class="text-xs text-pl-error">
        {{ 'login.errors.unexpected_error' | translate }}
      </p>
    </div>
  </div>
</div>
